import { Dialog } from "@mui/material";
import { useEffect, useState } from "react";
import { ProjectWizardDetailsStep } from "src/pages/ProjectDetailsWizard/ProjectWizardDetailsStep";
import { useCreateProjectMutation } from "src/api/v2/project-v2-ApiSlice";
import { useNavigate } from "react-router";
import { Projects, UserLabels } from "src/model/api/v2/data-contracts";
import { useAppDispatch } from "src/app/hooks";
import { plannerUiSlice } from "src/api/planner-ui-slice";
import { showSnackBar } from "src/api/ui-slice";
import { ts } from "src/utils/translate";

interface ProjectDetailsWizardProps {
    open: boolean;
    onClose: () => void;
    project?: Projects;
    labels?: UserLabels[];
    floor?: any;
}

export const ProjectWizard = ({ open, onClose, project, labels, floor }: ProjectDetailsWizardProps) => {

    const [createProject] = useCreateProjectMutation();

    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const [formData, setFormData] = useState({
        id: project?.id,
        name: project?.project_name || '',
        country: project?.country || 'Hungary',
        city: project?.city || '',
        address: project?.street_address || '',
        zip: project?.zip_code || '',
        tags: labels || [],
    });

    useEffect(() => {
        setFormData({
            id: project?.id,
            name: project?.project_name || '',
            country: project?.country || 'Hungary',
            city: project?.city || '',
            address: project?.street_address || '',
            zip: project?.zip_code || '',
            tags: labels || [],
        });
    }, [open, project, floor, labels]);

    const openNewProjectPlanner = (projectId: number) => {
        dispatch(plannerUiSlice.actions.setOpenFloorWizardAfterProjectCreation(true));
        navigate(`/planner/${projectId}`);
    };

    const handleSaveProject = () => {
        createProject({
            project_id: formData.id,
            project_name: formData.name,
            country: formData.country,
            city: formData.city,
            street_address: formData.address,
            zip_code: formData.zip,
            labelIds: formData.tags.map((tag: any) => tag.id)
        })
            .unwrap()
            .then((response) => {
                if (formData.id) {
                    onClose();
                } else {
                    openNewProjectPlanner(response.id);
                }
            })
            .catch(() => {
                dispatch(showSnackBar({ text: ts('save_project_error', 'Failed to save project'), severity: 'error' }));
            });
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
        >
            <ProjectWizardDetailsStep
                formData={formData}
                setFormData={setFormData}
                onNext={handleSaveProject}
                onClose={onClose}
            />
        </Dialog>
    );
};
